const listRegions = [
  { value: '01', label: 'Guadeloupe' },
  { value: '02', label: 'Martinique' },
  { value: '03', label: 'Guyane' },
  { value: '04', label: 'La Réunion' },
  { value: '06', label: 'Mayotte' },
  { value: '11', label: 'Île-de-France' },
  { value: '24', label: 'Centre-Val de Loire' },
  { value: '27', label: 'Bourgogne-Franche-Comté' },
  { value: '28', label: 'Normandie' },
  { value: '32', label: 'Hauts-de-France' },
  { value: '44', label: 'Grand Est' },
  { value: '52', label: 'Pays de la Loire' },
  { value: '53', label: 'Bretagne' },
  { value: '75', label: 'Nouvelle-Aquitaine' },
  { value: '76', label: 'Occitanie' },
  { value: '84', label: 'Auvergne-Rhône-Alpes' },
  { value: '93', label: "Provence-Alpes-Côte d'Azur" },
  { value: '94', label: 'Corse' },
]

export default listRegions
